'use client';
import PropTypes from 'prop-types';
import * as React from 'react';
import { FloatingLabelContextProvider } from '../../contexts/internal/floating-label/index.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const propTypes = {
    /**
   * Whether or not to have the Dropdown expand to fill its container's width
   * @default false
   */ fullWidth: PropTypes.bool
};
/**
 * @subcomponent Dropdown
 */ const DropdownWithFloatingLabel = renderWithRef('DropdownWithFloatingLabel', propTypes, (props, ref)=>{
    const { fullWidth = false, children } = props, rest = _object_without_properties(props, [
        "fullWidth",
        "children"
    ]);
    const classNames = new Set([
        'swan-vanilla-ignore',
        'swan-dropdown-with-floating-label'
    ]);
    if (fullWidth) classNames.add(`swan-dropdown-with-floating-label-full-width`);
    return /*#__PURE__*/ React.createElement(FloatingLabelContextProvider, null, /*#__PURE__*/ React.createElement(RenderComp, {
        root: "div",
        forwardedRef: ref,
        props: rest,
        classNames: classNames
    }, children));
});

export { DropdownWithFloatingLabel };
